import { hasValue, getFirstElementIndex, getLastElementIndex } from "./utils";
export const CONTROL_BY_TAB_KEY = "CONTROL_BY_TAB_KEY";
export const CONTROL_BY_ARROW_KEY = "CONTROL_BY_ARROW_KEY";
function setListElement(list, value, index) {
    list[index] = value;
}
function findActiveElementIndex(list) {
    return list.findIndex(v => hasValue(v) && v.isSelected === true);
}
function handleSelectElement(config, byKey = true) {
    config.isSelected = true;
    config.onSelectCallback(byKey);
}
function handleDeselectElement(config) {
    config.isSelected = false;
    config.onDeselectCallback();
}
export function registerElement(element, options) {
    var _a;
    const configList = options.configList;
    const index = options.index;
    const config = options.config;
    const selectOnHover = (_a = options.selectOnHover) !== null && _a !== void 0 ? _a : true; // select element on mouse hovering is default behavior
    let disabled = options.disabled;
    if (!disabled) {
        setListElement(configList, config, index);
    }
    function handleMouseEnter() {
        if (disabled)
            return;
        let activeIndex = findActiveElementIndex(configList);
        if (activeIndex !== -1) {
            let activeConfig = configList[activeIndex];
            handleDeselectElement(activeConfig);
        }
        handleSelectElement(config, false);
    }
    function handleMouseLeave() {
        if (disabled)
            return;
        handleDeselectElement(config);
    }
    function handleEnterKeyDown(event) {
        if (!disabled
            && typeof config.onEnterKeyCallback === "function"
            && event.key === "Enter"
            && config.isSelected) {
            config.onEnterKeyCallback(event);
        }
    }
    if (selectOnHover) {
        element.addEventListener("mouseenter", handleMouseEnter);
        element.addEventListener("mouseleave", handleMouseLeave);
    }
    document.addEventListener("keydown", handleEnterKeyDown);
    return {
        update(options) {
            disabled = options.disabled;
            if (disabled) {
                setListElement(configList, undefined, index);
            }
            else {
                setListElement(configList, config, index);
            }
        },
        destroy() {
            setListElement(configList, undefined, index);
            if (selectOnHover) {
                element.removeEventListener("mouseenter", handleMouseEnter);
                element.removeEventListener("mouseleave", handleMouseLeave);
            }
            document.removeEventListener("keydown", handleEnterKeyDown);
        }
    };
}
export function keyControlAction(element, options) {
    var _a;
    let { configList, disabled } = options;
    const keyControlType = (_a = options.keyControlType) !== null && _a !== void 0 ? _a : CONTROL_BY_ARROW_KEY;
    function getFirstIndex(from) {
        if (!hasValue(from)) {
            from = -1;
        }
        return getFirstElementIndex(configList, (v) => hasValue(v), from);
    }
    function getLastIndex(from) {
        if (!hasValue(from)) {
            from = configList.length;
        }
        return getLastElementIndex(configList, (v) => hasValue(v), from);
    }
    function getNextIndex(idx) {
        let result;
        result = getFirstIndex(idx);
        if (result === -1) {
            result = getFirstIndex();
        }
        return result;
    }
    function getPreviousIndex(idx) {
        let result;
        result = getLastIndex(idx);
        if (result === -1) {
            result = getLastIndex();
        }
        return result;
    }
    function navigateDown() {
        let currIdx = findActiveElementIndex(configList);
        let config;
        if (currIdx === -1) {
            config = configList[getFirstIndex()];
            handleSelectElement(config);
        }
        else {
            config = configList[getNextIndex(currIdx)];
            if (!config) {
                return;
            }
            handleDeselectElement(configList[currIdx]);
            handleSelectElement(config);
        }
    }
    function navigateUp() {
        let currIdx = findActiveElementIndex(configList);
        let config;
        if (currIdx === -1) {
            config = configList[getLastIndex()];
            handleSelectElement(config);
        }
        else {
            config = configList[getPreviousIndex(currIdx)];
            if (!config) {
                return;
            }
            handleDeselectElement(configList[currIdx]);
            handleSelectElement(config);
        }
    }
    function handleKeyDown(event) {
        if (disabled) {
            return;
        }
        if (keyControlType === CONTROL_BY_ARROW_KEY) {
            switch (event.key) {
                case "ArrowUp": {
                    navigateUp();
                    event.preventDefault();
                    break;
                }
                case "ArrowDown": {
                    navigateDown();
                    event.preventDefault();
                    break;
                }
                default:
                    break;
            }
        }
        else {
            const isShift = event.shiftKey;
            if (event.key !== "Tab") {
                return;
            }
            if (!isShift) {
                navigateDown();
            }
            else {
                navigateUp();
            }
            event.preventDefault();
        }
    }
    options.selectFromOutside = (idx) => {
        const activeIndex = findActiveElementIndex(configList);
        const activeConfig = configList[activeIndex];
        const config = configList[idx];
        if (hasValue(activeConfig)) {
            activeConfig.isSelected = false;
        }
        if (hasValue(config)) {
            config.isSelected = true;
        }
    };
    options.deselectFromOutside = (idx) => {
        const config = configList[idx];
        if (hasValue(config) && config.isSelected) {
            config.isSelected = false;
        }
    };
    document.addEventListener("keydown", handleKeyDown);
    return {
        update(options) {
            disabled = options.disabled;
        },
        destroy() {
            configList = undefined;
            document.removeEventListener("keydown", handleKeyDown);
        }
    };
}
